// removed by extract-text-webpack-plugin
module.exports = {"inventoryRecordListElement":"lSsPS","left":"SD928","photo":"_2Zi-X","details":"_1GHoM","middle":"_3T9Ms","name":"V34FT","buttonContainer":"_377XL","right":"_38hAf","description":"CyPNt","featuredBadge":"_3FJGt","price":"CZVuj","removeButton":"_2FBZ8","buyButton":"_1jQvi","strikethrough":"_3LTgn","heartButton":"_3P9NG","ratings":"Y9O-W"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventoryRecordListElement/index.sass
// module id = 1480
// module chunks = 1